import React from 'react';
import { useAuth } from '@trimble-oss/trimble-id-react';
import ErrorPage from '@/pages/ErrorPage/ErrorPage';
import LoadingPage from '../../components/LoadingPage/LoadingPage';
import { PAGES } from '@/pages/PAGE_CONSTANTS';
import Navigate from '@/routers/Navigate';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: 'rgb(241, 241, 246)',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: 'rgb(0, 0, 0)',
  },
  description: {
    fontSize: '1rem',
    color: 'rgb(0, 0, 0)',
  },
  button: {
    backgroundColor: '#0063a3',
    color: '#fff',
    padding: '0.5rem 1rem',
    textDecoration: 'none',
  },
};

const CallbackPage = () => {
  const { isLoading, error, isAuthenticated } = useAuth();
  if (isAuthenticated) {
    return <Navigate pageName={PAGES.HOME} />;
  }

  return (
    <main style={styles.container}>
      {error && <ErrorPage />}
      {isLoading && <LoadingPage />}
    </main>
  );
};

export default CallbackPage;
